"use strict";

(function ($) {
  /*--------------------------------------------------*/

  /* 共通 */
  var GLOBAL = {
    $window: $(window),
    $body: $('body'),
    $html: $('html'),
    $mask: $('#hogosha_mask')
  };
  /*--------------------------------------------------*/

  /* ヘッダー */

  GLOBAL.Header = {
    $header: $('#hogosha_header'),
    $menuBtn: $('#hogosha_header .menuBtn'),
    $menuBtnSP: $('#hogosha_header .menuBtn .menuBtn-menu'),
    $submenu: $('#hogosha_header .submenu '),
    $submenu_list: $('#hogosha_header .submenu_list')
  };
  var targetElement = document.querySelector("#hogosha_header .submenu");
  var spWindow = 767;
  var spFlg = GLOBAL.$window.innerWidth() <= spWindow ? true : false;
  var timer;

  function resetMethod() {
    GLOBAL.Header.$menuBtn.removeClass('js-active');
    GLOBAL.$mask.removeAttr('style').removeClass('js-active');
    ;
    GLOBAL.Header.$submenu.removeAttr('style').removeClass('js-active');
  } //初期化
  // $(".js-switch").each(function(){
  // 	var data= $(this).find("li:first").data("tab");
  // 	$(this).find("li:first").addClass("js-active");
  // 	$(".js-content." + data).addClass("js-active");
  // });


  var getHash = '';
  $(".js-switch *[data-tab]").on("click", function () {
    // if(window.location.search){
    //   window.location.search = "";
    // }

    $(this).closest('.js-switch').find("[data-tab]").removeClass("js-active");
    $(this).closest('.js-switch').siblings(".js-content").removeClass("js-active");
    var tabData = $(this).data("tab");
    $(this).addClass("js-active");
    $(".js-content." + tabData).addClass("js-active");
    $(".adjust_content *").removeClass("js-active");
    var target = $(".js-switch").eq(0).find("li.js-active").data("tab");

    if ($("." + tabData).find(" li").hasClass("js-active")) {
      var tabData02 = $("." + tabData).find(" li.js-active").data("tab");
      $(".adjust_content ." + tabData02).addClass("js-active");
      window.location.hash = target + "&" + tabData02;
    } else {
      $(".adjust_content ." + tabData).addClass("js-active");

      if (target != tabData) {
        window.location.hash = target + "&" + tabData;
      } else {
        window.location.hash = target;
      }
    }
    $(this).closest('.js-switch').find('[data-tab-friend]').removeClass('js-active')
    $(this).closest('.js-switch').find('[data-tab-friend="' + tabData + '"]').addClass('js-active');
  });
  var ua = navigator.userAgent.toLowerCase();
  var isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);

  if (!isMobile) {
    $('a[href^="tel:"]').on('click', function (e) {
      e.preventDefault();
    });
  }
  $('a[data-ancker]').on('click', function (e) {
    e.preventDefault();
    var target = $(this).data("ancker");
    $("#"+ target).parents(".acd").find(".acd_a").show();
      var offset = 0;
      if($('.sticky-header').get(0)) {
        offset = $('.sticky-header').outerHeight();
      }
      $("html, body").animate({scrollTop: $("#"+ target).offset().top - offset}, 0);
  });

  $("#hogosha_header .header-menu02 li").each(function (i) {
    var pathName = location.pathname;
    var pair = location.pathname.split('/');
    var re_pair = [];

    for (var i = 0; i < pair.length; i++) {
      if (pair[i] !== "") {
        re_pair.push(pair[i]);
      }
    }

    var innerUrl = $(this).data("href");

    if (innerUrl === re_pair[re_pair.length - 1]) {
      $(this).addClass("js-current");
    }
  });
  $(".acd_q").on("click", function () {
    if ($(this).parent().hasClass("js-active")) {
      $(this).parent().removeClass("js-active");
      $(this).next(".acd_a").slideUp();
    } else {
      $(this).parent().addClass("js-active");
      $(this).next(".acd_a").slideDown();
    }
  });
  /*
  * What is the Device?
  */

  var useDevice = getUserType();

  function getUserType() {
    var ua = ["iPod", "iPad", "iPhone", "Android"];

    for (var i = 0; i < ua.length; i++) {
      if (navigator.userAgent.indexOf(ua[i]) > 0) {
        return ua[i];
      }
    }

    return "Other";
  }

  if (useDevice == "Other") {
    $("body").addClass("hogosha_pc");
  }

  GLOBAL.$window.on('load resize', function () {
    /* reset*/
    if (spFlg === false && GLOBAL.$window.innerWidth() > spWindow) {
      //PC
      spFlg = true;
      resetMethod();
      bodyScrollLock.clearAllBodyScrollLocks();
      /*リンク先入れ替え処理*/

      $('body').find('[data-pc-href]').each(function () {
        $(this).attr('href', $(this).attr('data-pc-href'));
      });

      if (useDevice == "Other") {
        // User is useing PC Device
        GLOBAL.Header.$menuBtn.bind('mouseenter mouseleave');
        GLOBAL.Header.$menuBtn.mouseenter(function () {
          clearTimeout(timer);
          GLOBAL.Header.$submenu.css({
            'height': GLOBAL.Header.$submenu_list.outerHeight()
          }, 10, "easeInCubic");
          GLOBAL.Header.$menuBtn.addClass('js-active');
        }).mouseleave(function () {
          GLOBAL.Header.$submenu.stop().animate({
            'height': 0
          }, 5, "easeInCubic", function () {});
          timer = setTimeout(function () {
            GLOBAL.Header.$menuBtn.removeClass('js-active');
          }, 200);
        });
      } else {
        // User is useing Tablet
        GLOBAL.Header.$menuBtn.bind('click');
        GLOBAL.Header.$menuBtn.on("click", function () {
          clearTimeout(timer);

          if ($(this).hasClass('js-active')) {
            GLOBAL.Header.$submenu.stop().animate({
              'height': 0
            }, 5, "easeInCubic");
            timer = setTimeout(function () {
              GLOBAL.Header.$menuBtn.removeClass('js-active');
            }, 200);
            GLOBAL.$mask.removeClass("js-active");
          } else {
            GLOBAL.Header.$submenu.css({
              'height': GLOBAL.Header.$submenu_list.outerHeight()
            }, 10, "easeInCubic");
            $(this).addClass('js-active');
            GLOBAL.$mask.addClass("js-active");
          }

          $('#hogosha_mask,.closeBtn').on('click', function (e) {
            e.preventDefault();
            bodyScrollLock.clearAllBodyScrollLocks();
            GLOBAL.Header.$menuBtn.removeClass('js-active');
            GLOBAL.Header.$submenu.stop().animate({
              'height': 0
            }, 5, "easeInCubic");
            GLOBAL.$mask.removeClass("js-active");
          });
        });
      }


    }

    if (spFlg === true && GLOBAL.$window.innerWidth() <= spWindow) {
      //SP
      spFlg = false;
      resetMethod();
      GLOBAL.Header.$menuBtn.unbind('click mouseenter mouseleave');
      GLOBAL.Header.$menuBtnSP.on('click', function (e) {
        e.preventDefault();
        GLOBAL.Header.$submenu.removeAttr("style");
        bodyScrollLock.disableBodyScroll(targetElement);
        GLOBAL.Header.$submenu.addClass('js-active');
        GLOBAL.$mask.addClass("js-active");
      });
      /* header Menu Close */

      $('#hogosha_mask,.closeBtn').on('click', function (e) {
        e.preventDefault();
        bodyScrollLock.clearAllBodyScrollLocks();
        GLOBAL.Header.$submenu.removeClass('js-active');
        GLOBAL.$mask.removeClass("js-active");
      });
      /*リンク先入れ替え処理*/

      $('body').find('[data-sp-href]').each(function () {
        $(this).attr('href', $(this).attr('data-sp-href'));
      });
    }

    if($("#app_banner,#app_banner02").length > 0){
      $("#hogosha_footer").css({
        "padding-bottom" : $("#app_banner,#app_banner02").outerHeight()
      });
    }
  });


  $('[data-type="modal"]').on("click", function (e) {
    e.preventDefault();
    var targetModal = $(this).data("modal");
    var get_targetModal = $(".G_modal_content." + targetModal).html();
    var modal = '<div class="G_modal_mask">' + '<div class="G_modal">' + '<div class="G_modal_scroll">' + '<div class="G_modal_content">' + '<p class="G_modal_content_close"></p>' + get_targetModal + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
    $('body').append(modal);
    setTimeout(function () {
      $(".G_modal_mask").addClass("is-active");
    }, 300);
  });
  $(document).on("click", ".G_modal_mask,.G_modal_content_close", function (e) {
    if ($(e.target).closest('.G_modal_content').get(0)) {
      if (!$(e.target).hasClass('G_modal_content_close')) {
        return;
      }
    }

    $(".G_modal_mask").removeClass("is-active");
    setTimeout(function () {
      $(".G_modal_mask").remove();
    }, 100);
  });
  var ua = navigator.userAgent.toLowerCase();
  var isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);

  if (!isMobile) {
    // $('a[href^="tel:"]').attr("href", "javascript:void(0)");
    $('a[href^="tel:"]').removeAttr("href").css({
      "cursor": "default"
    });
  } //Browser Back


  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      // ここにキャッシュ有効時の処理を書く
      hashTab();
    }
  });
  GLOBAL.$window.on('load', function () {
    hashTab();
    $('#app_banner02 a').eq(Math.floor(Math.random() * 2)).show()



  });

  function hashTab() {
    var getHash = window.location.hash.substring(1).split("&");
    var getSearch = window.location.search;

    if(location.hash.match(/^#([^\/]+)\/([^\/]+)$/)) {
      getHash = [ RegExp.$1 ];
      getSearch = RegExp.$2;
    }
    if (getHash[0].length == 0) return; //hashがない場合は止める

    $(".js-switch").eq(0).find("li").removeClass("js-active");

    for (var i = 0; i < getHash.length; i++) {
      $('[data-tab="' + getHash[i] + '"]').addClass("js-active").siblings().removeClass("js-active");
      $("." + getHash[i]).siblings(".js-content").removeClass("js-active");
      $("." + getHash[i]).addClass("js-active");
      $(".adjust_content .js-content").removeClass("js-active");
      $(".adjust_content").find("." + getHash[i]).addClass("js-active");

      //
      $('[data-tab="' + getHash[i] + '"]').children('.acd_a').show();

      $('[data-tab="' + getHash[i] + '"]').click();
    }
    if(getSearch){
      var anchorPar = getSearch.split("=");
      var anchorObg = $("#"+ anchorPar[anchorPar.length-1])

      if(anchorObg.get(0)) {
        var pospos = anchorObg.offset().top;

        if(anchorObg.closest('.acd').get(0)) {
          anchorObg.closest('.acd').addClass('js-active').children('.acd_a').show();
        }
        var offset = 0;
        if($('.sticky-header').get(0)) {
          offset = $('.sticky-header').outerHeight();
        }
        $("html, body").animate({scrollTop: pospos - offset}, 400);
      }
    }
  }
  if($(".hogosha-slide").get(0)){
    $('.hogosha-slide').slick({
      autoplay: true,
      autoplaySpeed: 15000,
      infinite: true,
      // speed: 1000,
      fade: false,
      cssEase: 'ease',
      dots: true,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
    });

  }


  /**
   * fixed banner 追加
   */
  var scrollActionFlg = true;
  var fixedtimer;
  setTimeout(function() {
      scrollActionFlg = false;
  }, 500);

  $(window).on("scroll",function(){
    if(!scrollActionFlg) {
      clearTimeout(fixedtimer);
      $("#app_banner,#app_banner02").addClass("js-hide");

      fixedtimer = setTimeout(function(){
        $("#app_banner,#app_banner02").removeClass("js-hide");
      }, 500)
    }
  });

  var bnr_parmetter = location.search.substring(1);
  var reBnr = new RegExp("transit=app");
  var rePar = /\?/;
  // var rePar = new RegExp("?");
  // $("#hogosha_footer").prepend('<p style="color:white">' + bnr_parmetter + '</p>');
  if(reBnr.test(bnr_parmetter)) {
    $("#app_banner.#app_banner02").hide();

    $("a").each(function(){
      var target = $(this).attr("href");
      if(rePar.test(target)){
         $(this).attr("href", target + "&" + bnr_parmetter );
      }else{
         $(this).attr("href", target + "?" + bnr_parmetter );
      }
      // console.log($(this).attr("href"));

    });
  }

  if(reBnr.test(bnr_parmetter)) {
    $("#app_banner,#app_banner02").hide();

    $("a").each(function(){
      // if($(this).attr("href").test(rePar)){
      //   $(this).attr("href", $(this).attr("href") + "&" + bnr_parmetter );
      // }else{
      //   $(this).attr("href", $(this).attr("href") + "?" + bnr_parmetter );

      // }

      // console.log($(this).attr("href"));

    });
  }

  // //iOS
  // const IOS_STORE_URL = "https://www.benesse.co.jp/t/app/hogoshasite__store_apst/?s_apst=app_hogoshasite__store_00025";
  // const IOS_STORE_TAG = "s.linkTrackVars='events';s.linkTrackEvents='event166';s.events='event166';s.tl(this,'o','Forum_appDL_apple');s.events='';";

  // //Android
  // const ANDROID_STORE_URL = "https://www.benesse.co.jp/t/app/hogoshasite__store_apst/?s_apst=app_hogoshasite__store_00025";
  // const ANDROID_STORE_TAG = "s.linkTrackVars='events';s.linkTrackEvents='event166';s.events='event166';s.tl(this,'o','Forum_appDL_google');s.events='';";
  // const ANDROID_SCHEME = 'benesse';
  // const ANDROID_PACKAGE = 'jp.co.benesse.ParentsApp';

  // //WEB
  // // const MY_WEB_PAGE_URL = "https://example.com";
  // const MY_WEB_PAGE_URL = "https://benesse.jp/manabi/?s_oid=app_appdl00069&s_apst=app_appdl00069&pid=hogosha&c=ohdan&af_adset=ownedmedia&af_ad=gen_appdl00069&af_channel=AppDL";
  // const MY_WEB_PAGE_TAG = "";

  // //DOWNLOAD済みか
  // // const MY_APP_SCHEMA = "myapp://";

  // const LAG_TIME = 400;
  // const TIMEOUT = 1000;

  // if(useDevice == "Other"){
  //   $("#app_banner a").attr("href", MY_WEB_PAGE_URL);
  //   $("#app_banner a").attr("onclick", MY_WEB_PAGE_TAG);

  //   return false;
  // }

  // $("body").append("<iframe class='test src='" + MY_APP_SCHEMA  + "' style='display:none'/>");
  var checkedAt = (new Date()).getTime();

  window.setTimeout(function() {
      var lagtime = (new Date()).getTime() - checkedAt;

      // $("iframe.test").remove();
      if (lagtime > LAG_TIME) {

          if(useDevice == "iPhone"){
            $("#app_banner a").attr("href", IOS_STORE_URL);
            $("#app_banner a").attr("onclick", IOS_STORE_TAG);
            return false;
          }else if(useDevice == "Android"){
            $("#app_banner a").attr("href", ANDROID_STORE_URL);
            $("#app_banner a").attr("onclick", ANDROID_STORE_TAG);


            return false;
          }

      }
  }, TIMEOUT);
})(jQuery);
//# sourceMappingURL=../sourcemaps/main.js.map
